module.exports = __webpack_public_path__ + "img/BUTAGAZ_80X30.3013d70f.png";